import React, { ReactNode } from "react";

export default function renderTerms(): ReactNode {
	return (
		<div className="max-w-3xl mx-auto px-5 py-5 leading-relaxed">
			<h1 className="text-primary font-bold mb-5 text-3xl">TERMS OF SERVICE</h1>
			<ol className="list-none pl-0 [counter-reset:section]">
				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">ACCEPTANCE OF TERMS</span>
					<div>
						These Terms of Service ("Terms") govern your access to and use of
						JobMap (the "Service"), a product offered by JobMap ("Company,"
						"we," or "us"). By accessing or using the Service, you agree to be
						bound by these Terms. If you disagree with any part of the Terms,
						you may not access the Service.
					</div>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">DESCRIPTION OF SERVICE</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							JobMap is a digital platform designed to assist job seekers in
							identifying employment opportunities through database utilization.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							The Company reserves the right to modify, suspend, or discontinue
							the Service at any time without notice.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">ELIGIBILITY AND ACCOUNT CREATION</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							To be eligible to use the Service, you must be at least 18 years
							of age and possess the legal capacity to enter into binding
							agreements.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							To create an account, you must provide accurate and complete
							information, including but not limited to your name, email
							address, credit card details, and resume.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							You are responsible for maintaining the confidentiality of your
							account information and for all activities that occur under your
							account.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">USER OBLIGATIONS</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							You agree to use the Service in compliance with all applicable
							laws and regulations.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							You shall not:
							<ul className="list-lower-alpha ml-10 mt-2.5">
								<li>Violate any intellectual property rights;</li>
								<li>Provide false or misleading information;</li>
								<li>
									Interfere with or disrupt the Service or servers or networks
									connected to the Service;
								</li>
								<li>
									Circumvent, disable, or otherwise interfere with
									security-related features of the Service.
								</li>
							</ul>
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">COMPANY RIGHTS AND RESPONSIBILITIES</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							The Company shall provide the Service as described herein.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							The Company reserves the right to:
							<ul className="list-lower-alpha ml-10 mt-2.5">
								<li>
									Modify, suspend, or terminate the Service or any user's access
									to it;
								</li>
								<li>Remove content that violates these Terms;</li>
								<li>Update these Terms at any time.</li>
							</ul>
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">INTELLECTUAL PROPERTY</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							All content and materials provided by the Company are protected by
							copyright and other intellectual property laws.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							Users retain rights to their own content but grant the Company a
							non-exclusive, worldwide, royalty-free license to use, reproduce,
							and distribute such content for the purposes of providing and
							improving the Service.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">PRIVACY AND DATA PROTECTION</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							The Company's collection and use of personal information is
							governed by its Privacy Policy, which is incorporated by reference
							into these Terms.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">PAYMENT AND REFUNDS</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							Payment terms and refund policies are as set forth in the
							Company's Refund Policy, available on our website.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">TERMINATION</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							Users may terminate their account at any time by following the
							procedures outlined in the Service.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							The Company may terminate or suspend access to the Service
							immediately, without prior notice or liability, for any reason
							whatsoever.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">DISCLAIMER OF WARRANTIES</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS.
							THE COMPANY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS
							OR IMPLIED.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">LIMITATION OF LIABILITY</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							IN NO EVENT SHALL THE COMPANY BE LIABLE FOR ANY INDIRECT,
							INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING
							WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER
							INTANGIBLE LOSSES.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">GOVERNING LAW AND JURISDICTION</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							These Terms shall be governed by and construed in accordance with
							the laws of Deleware.
						</li>
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							Any dispute arising out of or in connection with these Terms shall
							be subject to the exclusive jurisdiction of the courts of
							Deleware.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">AMENDMENTS</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							The Company reserves the right to amend these Terms at any time.
							Users will be notified of significant changes, and continued use
							of the Service constitutes acceptance of the modified Terms.
						</li>
					</ol>
				</li>

				<li className="mb-5 before:content-[counter(section)_'._'] before:font-bold [counter-increment:section]">
					<span className="font-bold">SEVERABILITY</span>
					<ol className="list-none ml-5 mt-2.5 [counter-reset:subsection]">
						<li className="mt-1.5 before:content-[counter(section)'.'counter(subsection)'._'] [counter-increment:subsection]">
							If any provision of these Terms is held to be unenforceable or
							invalid, such provision will be changed and interpreted to
							accomplish the objectives of such provision to the greatest extent
							possible under applicable law, and the remaining provisions will
							continue in full force and effect.
						</li>
					</ol>
				</li>
			</ol>

			<p className="text-primary mt-5">
				BY USING THE SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS OF
				SERVICE, UNDERSTAND THEM, AND AGREE TO BE BOUND BY THEM.
			</p>
		</div>
	);
}
